import {
  View,
  Text,
  ScrollView,
  TextInput,
  TouchableOpacity,
  ActivityIndicator,
  StyleSheet,
} from "react-native";
import React, { useEffect, useState, useMemo } from "react";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
import Header from "../components/Header";
import { Ionicons } from "@expo/vector-icons";

const UserOrders = ({ navigation }) => {
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    getDocs(collection(db, "users")).then((snap) => {
      const list = [];
      snap.forEach((doc) => {
        const d = doc.data();
        if (d?.data) list.push(d);
      });
      list.sort((a, b) =>
        (a.data.APELLIDO ?? "").localeCompare(b.data.APELLIDO ?? "")
      );
      setClientes(list);
      setLoading(false);
    });
  }, []);

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return clientes;
    return clientes.filter(
      (c) =>
        c.data.APELLIDO?.toLowerCase().includes(q) ||
        String(c.data.CUIT ?? "").includes(q)
    );
  }, [search, clientes]);

  return (
    <View style={s.container}>
      <Header title="Clientes" navigation={navigation} isBack={true} />

      <View style={s.searchBar}>
        <Ionicons name="search-outline" size={18} color="#aaa" style={s.searchIcon} />
        <TextInput
          style={s.searchInput}
          placeholder="Buscar por nombre o CUIT..."
          placeholderTextColor="#aaa"
          value={search}
          onChangeText={setSearch}
          autoCorrect={false}
          autoCapitalize="none"
          clearButtonMode="while-editing"
        />
        {search.length > 0 && (
          <TouchableOpacity onPress={() => setSearch("")}>
            <Ionicons name="close-circle" size={18} color="#aaa" />
          </TouchableOpacity>
        )}
      </View>

      {loading ? (
        <View style={s.centered}>
          <ActivityIndicator size="large" color="#080680" />
          <Text style={s.loadingText}>Cargando clientes...</Text>
        </View>
      ) : (
        <ScrollView
          style={s.scroll}
          contentContainerStyle={s.scrollContent}
          showsVerticalScrollIndicator={false}
        >
          {filtered.length === 0 ? (
            <View style={s.centered}>
              <Ionicons name="people-outline" size={56} color="#ddd" />
              <Text style={s.emptyText}>
                {search ? "Sin resultados para esa búsqueda." : "No hay clientes registrados."}
              </Text>
            </View>
          ) : (
            filtered.map((item, index) => (
              <TouchableOpacity
                key={index}
                style={s.card}
                onPress={() => navigation.navigate("Single", item)}
                activeOpacity={0.8}
              >
                <View style={s.cardLeft}>
                  <View style={s.avatar}>
                    <Text style={s.avatarText}>
                      {(item.data.APELLIDO ?? "?")[0].toUpperCase()}
                    </Text>
                  </View>
                </View>
                <View style={s.cardBody}>
                  <Text style={s.name}>{item.data.APELLIDO ?? "Sin nombre"}</Text>
                  <Text style={s.cuit}>CUIT: {item.data.CUIT ?? "—"}</Text>
                  {item.data.MAIL ? (
                    <Text style={s.mail}>{item.data.MAIL}</Text>
                  ) : null}
                </View>
                <Ionicons name="chevron-forward-outline" size={18} color="#ccc" />
              </TouchableOpacity>
            ))
          )}
          <View style={{ height: 40 }} />
        </ScrollView>
      )}
    </View>
  );
};

export default UserOrders;

const s = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#F4F6FD",
  },
  searchBar: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#fff",
    margin: 16,
    marginBottom: 8,
    borderRadius: 10,
    paddingHorizontal: 12,
    paddingVertical: 10,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.04,
    shadowRadius: 3,
    elevation: 1,
    gap: 8,
  },
  searchIcon: {
    marginRight: 2,
  },
  searchInput: {
    flex: 1,
    fontSize: 15,
    color: "#333",
  },
  centered: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    marginTop: 60,
  },
  loadingText: {
    marginTop: 10,
    color: "#666",
  },
  emptyText: {
    marginTop: 14,
    color: "#999",
    fontSize: 15,
  },
  scroll: {
    flex: 1,
  },
  scrollContent: {
    paddingHorizontal: 16,
    paddingTop: 8,
  },
  card: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#fff",
    borderRadius: 12,
    padding: 14,
    marginBottom: 10,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 4,
    elevation: 2,
    gap: 12,
  },
  cardLeft: {
    alignItems: "center",
  },
  avatar: {
    width: 44,
    height: 44,
    borderRadius: 22,
    backgroundColor: "#080680",
    alignItems: "center",
    justifyContent: "center",
  },
  avatarText: {
    color: "#fff",
    fontSize: 18,
    fontWeight: "700",
  },
  cardBody: {
    flex: 1,
    gap: 2,
  },
  name: {
    fontSize: 15,
    fontWeight: "700",
    color: "#1a1a1a",
  },
  cuit: {
    fontSize: 13,
    color: "#555",
  },
  mail: {
    fontSize: 12,
    color: "#999",
  },
});
